import { render, staticRenderFns } from "./PermitsSection.vue?vue&type=template&id=39dbcf89"
import script from "./PermitsSection.vue?vue&type=script&lang=js"
export * from "./PermitsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports